import React from 'react'
import AboutUs from '../Components/AboutUs/AboutUs'
import Navbar2 from "../Components/Navbar/Navbar2"
import Footer from "../Components/Footer/Footer"

export default function AboutUsPage() {
  return (
    <div>
        <Navbar2/>
        <AboutUs/>
        <Footer/>
    </div>
  )
}
